import { Component } from '@angular/core';
import { AppstateService } from 'src/app/services/appstate.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-sidepanel',
  // standalone: true,
  // imports: [],
  templateUrl: './sidepanel.component.html',
  styleUrl: './sidepanel.component.css'
})
export class SidepanelComponent {

  constructor(public appStateService: AppstateService){
  }

}
